(function () {
  'use strict';

  /* ── Helpers ── */
  const $ = (s, ctx = document) => ctx.querySelector(s);
  const $$ = (s, ctx = document) => [...ctx.querySelectorAll(s)];

  /* ══ PRODUCT + IMAGE DATA ══ */
  const productEl = $('#dpProductJson');
  const imagesEl  = $('#dpImagesJson');
  if (!productEl) return;

  const product  = JSON.parse(productEl.textContent);
  const variants = product.variants;
  const images   = imagesEl ? JSON.parse(imagesEl.textContent) : [];

  /* ══ GALLERY ══ */
  const mainImg   = $('#dpMainImg');
  const mainImg2  = $('#dpMainImg2');
  const thumbBtns = $$('.dp-thumb');
  let currentIdx  = 0;

  /* visibleIndices holds the subset of `images` indices that should be
     shown for the currently selected color. Defaults to "all images". */
  let visibleIndices = images.map((_, i) => i);

  /* All distinct color values across variants (e.g. "Black", "Triple Black").
     Populated once colorOptionIndex is known, below. Needed so that selecting
     "Black" doesn't also pull in "Triple Black" images just because the word
     "black" appears inside "triple black". */
  let colorValues = [];

  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Whole word/phrase match (case-insensitive), not a raw substring match —
  // so "black" won't match inside an unrelated word, but WILL match the
  // "black" inside the phrase "triple black" (that ambiguity is resolved
  // separately in filterGalleryByColor via the moreSpecific check).
  function colorMatchesAlt(colorLower, altLower) {
    const re = new RegExp(`\\b${escapeRegex(colorLower)}\\b`);
    return re.test(altLower);
  }

  // Alt text can tag an image with more than one color by separating them
  // with commas, e.g. alt="Black, White" means this image should show up
  // for BOTH the Black and White swatches.
  function getAltColorTags(altText) {
    if (!altText) return [];
    return altText.split(',').map(t => t.trim().toLowerCase()).filter(Boolean);
  }

  function setImage(idx) {
    if (!images.length || !mainImg) return;
    idx = (idx + images.length) % images.length;
    currentIdx = idx;
    mainImg.src = images[idx].src;
    mainImg.alt = images[idx].alt || '';
    thumbBtns.forEach((b, i) => b.classList.toggle('active', i === idx));
    // scroll thumbnail into view
    if (thumbBtns[idx]) thumbBtns[idx].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });

    // Keep the SECOND stacked image showing the NEXT image within the
    // currently visible (color-filtered) set, not just idx+1 globally.
    if (mainImg2) {
      const pos = visibleIndices.indexOf(idx);
      if (pos !== -1 && visibleIndices.length > 1) {
        const nextIdx = visibleIndices[(pos + 1) % visibleIndices.length];
        mainImg2.src = images[nextIdx].src;
        mainImg2.alt = images[nextIdx].alt || '';
      } else if (images.length > 1) {
        // fallback if idx isn't in visibleIndices for some reason
        const nextIdx = (idx + 1) % images.length;
        mainImg2.src = images[nextIdx].src;
        mainImg2.alt = images[nextIdx].alt || '';
      }
    }
  }

  /* Step to the previous/next image, staying within visibleIndices
     (i.e. only cycling through the images that match the selected color). */
  function stepImage(dir) {
    if (!visibleIndices.length) return;
    let pos = visibleIndices.indexOf(currentIdx);
    if (pos === -1) pos = 0;
    const nextPos = (pos + dir + visibleIndices.length) % visibleIndices.length;
    setImage(visibleIndices[nextPos]);
  }

  /* Filter thumbnails/gallery down to images whose alt text contains the
     given color name. Falls back to showing all images if nothing matches
     (e.g. alt text wasn't set for that color) so the gallery never goes blank. */
  function filterGalleryByColor(colorValue) {
    if (window.__nmviGalleryOwned) return; // don't delete or touch - added by nova variant images

    if (!colorValue) {
      visibleIndices = images.map((_, i) => i);
    } else {
      const cv = colorValue.trim().toLowerCase();

      // Other real color values that are a more specific "superset" of this
      // one — e.g. if the selected color is "Black" and the color option
      // also has a "Triple Black" variant, that's more specific: any alt
      // text mentioning "triple black" belongs to THAT color, not this one.
      const moreSpecific = colorValues
        .map(v => v.trim().toLowerCase())
        .filter(other => other !== cv && colorMatchesAlt(cv, other));

      const matched = images
        .map((img, i) => ({ img, i }))
        .filter(({ img }) => {
          if (!img.alt) return false;
          const tags = getAltColorTags(img.alt);
          // Image matches this color if ANY of its comma-separated tags
          // corresponds to this color — but a tag only counts if it isn't
          // itself a more specific color name (so a "Triple Black" tag
          // doesn't count toward a plain "Black" selection).
          return tags.some(tag =>
            colorMatchesAlt(cv, tag) &&
            !moreSpecific.some(other => colorMatchesAlt(other, tag))
          );
        })
        .map(({ i }) => i);

      visibleIndices = matched.length ? matched : images.map((_, i) => i);
    }

    thumbBtns.forEach((btn, i) => {
      btn.style.display = visibleIndices.includes(i) ? '' : 'none';
    });

    if (visibleIndices.length) setImage(visibleIndices[0]);
  }

  // don't delete or touch - added by nova variant images
  window.dpSetVisibleIndices = function (indices) {
    visibleIndices = indices;
    thumbBtns.forEach((btn, i) => { btn.style.display = indices.includes(i) ? '' : 'none'; });

    // Thumbs are moved, not just shown: indices carries the merchant's configured order.
    const strip = thumbBtns[0] && thumbBtns[0].parentNode;
    if (strip) {
      indices.forEach((i) => { if (thumbBtns[i]) strip.appendChild(thumbBtns[i]); });
      thumbBtns.forEach((btn, i) => { if (!indices.includes(i)) strip.appendChild(btn); });
    }

    if (indices.length) setImage(indices[0]);
  };
  window.dpResetGallery = function () {
    filterGalleryByColor(colorOptionIndex !== null ? selectedOptions[colorOptionIndex] : null);
  };
  // End: don't delete or touch - added by nova variant images

  // Thumbnail clicks
  thumbBtns.forEach((btn, i) => {
    btn.addEventListener('click', () => setImage(i));
  });

  // Arrow buttons — now step within the filtered (color-matched) set
  const prevBtn = $('#dpImgPrev');
  const nextBtn = $('#dpImgNext');
  if (prevBtn) prevBtn.addEventListener('click', () => stepImage(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => stepImage(1));

  // Touch swipe on main image
  const mainWrap = $('#dpMainImageWrap');
  if (mainWrap) {
    let touchStartX = 0;
    mainWrap.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    mainWrap.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) stepImage(diff > 0 ? 1 : -1);
    });
  }

  /* ══ THUMBNAIL "SHOW MORE" ARROW ══
     Thumbnail list is capped at 6 visible; clicking the arrow
     expands to show all remaining thumbnails (scrollable). */
  const thumbsContainer = $('#dpThumbnails');
  const thumbMoreArrow  = $('#dpThumbMoreArrow');
  if (thumbMoreArrow && thumbsContainer) {
    thumbMoreArrow.addEventListener('click', () => {
      const expanded = thumbsContainer.classList.toggle('expanded');
      thumbMoreArrow.classList.toggle('rotated', expanded);
    });
  }

  /* ══ VARIANT SWITCHING ══
     FIX: Read initial selected state from the DOM (the "active" buttons that
     Liquid rendered), NOT from variants.find(v => v.available). This ensures
     JS state always matches the UI on page load, even when the first available
     variant is a different color/size than the first option set displayed.
     This also fixes Color + Size + Length + Width (4 options) where the old
     code would treat missing options as wildcards and match wrong variants. */
  const selectedOptions = {};

  // Step 1: Read whichever button Liquid marked as "active" for each option index.
  $$('[data-option-index]').forEach(btn => {
    const idx = parseInt(btn.dataset.optionIndex);
    if (btn.classList.contains('active') && selectedOptions[idx] === undefined) {
      selectedOptions[idx] = btn.dataset.value;
    }
  });

  // Step 2: If any option index still has no selection (e.g. no active class
  // was rendered for it), fall back to variants[0] values for that slot.
  const fallbackVariant = variants[0];
  fallbackVariant.options.forEach((val, i) => {
    if (selectedOptions[i] === undefined) selectedOptions[i] = val;
  });

  // initVariant: the variant that matches the DOM-derived selectedOptions,
  // used only to seed the gallery filter on page load.
  const initVariant = variants.find(v =>
    v.options.every((val, i) => selectedOptions[i] === val)
  ) || fallbackVariant;

  /* ── Detect which option index is the COLOR option
       by reading the DOM (works regardless of option order) ── */
  let colorOptionIndex = null;
  const firstColorSwatch = $('.dp-color-swatch[data-option-index], .dp-color-swatch-img[data-option-index]');
  if (firstColorSwatch) {
    colorOptionIndex = parseInt(firstColorSwatch.dataset.optionIndex);
  }

  /* ── Now that colorOptionIndex is known, collect every distinct color
       value this product has (e.g. "Black", "Triple Black", "White") so
       filterGalleryByColor can disambiguate overlapping names. ── */
  if (colorOptionIndex !== null) {
    colorValues = [...new Set(
      variants.map(v => v.options[colorOptionIndex]).filter(Boolean)
    )];
  }

  /* ── Set the initial color label on page load ── */
  const colorLabel = $('#dpColorValueLabel');
  if (colorLabel && colorOptionIndex !== null && initVariant.options[colorOptionIndex]) {
    colorLabel.textContent = initVariant.options[colorOptionIndex];
  }

  /* ── Apply the initial gallery filter for the starting color ── */
  if (colorOptionIndex !== null && initVariant.options[colorOptionIndex]) {
    filterGalleryByColor(initVariant.options[colorOptionIndex]);
  }

  $$('[data-option-index]').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = parseInt(btn.dataset.optionIndex);
      selectedOptions[idx] = btn.dataset.value;
      // Update active buttons in this group
      $$(`[data-option-index="${idx}"]`).forEach(b =>
        b.classList.toggle('active', b.dataset.value === btn.dataset.value));

      // If a color swatch was clicked, re-filter the gallery to that color
      if (colorOptionIndex !== null && idx === colorOptionIndex) {
        filterGalleryByColor(btn.dataset.value);
      }

      updateVariant();
    });
  });

  /* FIX: findVariant now requires ALL option indices to match exactly.
     The old version used `selectedOptions[i] === undefined` as a wildcard,
     which caused wrong variants to be selected when Length/Width weren't yet
     clicked — making stocked variants appear as "Sold Out". */
  function findVariant() {
    return variants.find(v =>
      v.options.every((val, i) => selectedOptions[i] === val)
    );
  }

  function updateVariant() {
    const v = findVariant();
    if (!v) return;

    // Variant ID
    const idInput = $('#dpVariantId');
    if (idInput) idInput.value = v.id;

    // Price
    const priceEl   = $('#dpPrice');
    const compareEl = $('#dpComparePrice');
    if (priceEl) priceEl.textContent = formatMoney(v.price);
    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = formatMoney(v.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // Color name label (e.g. "Color: Blue")
    const colorLabelEl = $('#dpColorValueLabel');
    if (colorLabelEl && colorOptionIndex !== null && v.options[colorOptionIndex]) {
      colorLabelEl.textContent = v.options[colorOptionIndex];
    }

    // Add to cart state
    const btn  = $('#dpAddToCart');
    const text = $('#dpAddToCartText');
    if (btn && text) {
      btn.disabled = !v.available;
      text.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
    }

    // Sticky mobile bar — mirror availability
    const stickyBtn  = $('#dpStickyAddToCart');
    const stickyText = $('#dpStickyAddToCartText');
    if (stickyBtn && stickyText) {
      stickyBtn.disabled = !v.available;
      stickyText.textContent = v.available ? 'ADD TO BAG' : 'SOLD OUT';
    }

    // Swap to variant image (still works fine on top of the color filter —
    // this just jumps within `images` to the variant's specific photo)
    if (v.featured_image) {
      const imgIdx = images.findIndex(img => img.src && img.src.includes(v.featured_image.id));
      if (imgIdx >= 0) setImage(imgIdx);
      else {
        // fallback: match by position
        const pos = v.featured_image.position - 1;
        if (pos >= 0 && pos < images.length) setImage(pos);
      }
    }

    markUnavailable();
  }

  /* FIX: markUnavailable also uses exact matching now (no undefined wildcards).
     Previously, when Length and Width weren't selected yet, the wildcard logic
     would mark ALL color swatches beyond index 3 as unavailable on page load,
     making them unclickable. Now every swatch is tested against the full
     current selectedOptions, so only genuinely out-of-stock combinations are
     greyed out. */
  function markUnavailable() {
    $$('[data-option-index]').forEach(btn => {
      const testOpts = { ...selectedOptions };
      testOpts[parseInt(btn.dataset.optionIndex)] = btn.dataset.value;
      const exists = variants.some(v =>
        v.options.every((val, i) => testOpts[i] === val)
      );
      btn.classList.toggle('unavailable', !exists);
    });
  }

  markUnavailable();

  /* ══ FORM SUBMIT — intercept and use cart drawer ══ */
  const form = $('#dpProductForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const variantId = $('#dpVariantId') ? $('#dpVariantId').value : null;
      if (!variantId) return;

      // Collect ANY properties[...] field inside the form — this covers
      // Weight/Height, and also whatever the Fast Product Options app
      // block injects for Personalization, so its selection isn't dropped.
      const properties = {};
      $$('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]', form)
        .forEach(field => {
          const match = field.name.match(/^properties\[(.+)\]$/);
          if (!match) return;
          if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
          const val = (field.value || '').trim();
          if (val) properties[match[1]] = val;
        });

      const btn  = $('#dpAddToCart');
      const text = $('#dpAddToCartText');
      const stickyBtn  = $('#dpStickyAddToCart');
      const stickyText = $('#dpStickyAddToCartText');
      if (btn) btn.disabled = true;
      if (text) text.textContent = 'ADDING…';
      if (stickyBtn) stickyBtn.disabled = true;
      if (stickyText) stickyText.textContent = 'ADDING…';

      const items = [{ id: parseInt(variantId), quantity: 1 }];
      if (Object.keys(properties).length > 0) items[0].properties = properties;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
        .then(r => r.json())
        .then(() => {
          if (text) text.textContent = 'ADDED ✓';
          if (stickyText) stickyText.textContent = 'ADDED ✓';
          setTimeout(() => {
            if (text) text.textContent = 'ADD TO CART';
            if (btn) btn.disabled = false;
            if (stickyText) stickyText.textContent = 'ADD TO BAG';
            if (stickyBtn) stickyBtn.disabled = false;
          }, 1500);
          // Open cart drawer
          if (window.dlOpenCart) {
            window.dlFetchCart && window.dlFetchCart();
            window.dlOpenCart();
          }
          // Update cart count
          return fetch('/cart.js');
        })
        .then(r => r && r.json())
        .then(cart => {
          if (cart) {
            const countEl = document.getElementById('cart-count');
            if (countEl) {
              countEl.textContent = cart.item_count;
              countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
            }
          }
        })
        .catch(() => {
          if (text) text.textContent = 'ERROR – TRY AGAIN';
          if (btn) btn.disabled = false;
          if (stickyText) stickyText.textContent = 'ERROR – TRY AGAIN';
          if (stickyBtn) stickyBtn.disabled = false;
        });
    });
  }

  /* ══ ACCORDIONS ══ */
  $$('[data-accordion]').forEach(acc => {
    const header = acc.querySelector('.dp-accordion-header');
    const body   = acc.querySelector('.dp-accordion-body');
    if (!header || !body) return;
    header.addEventListener('click', () => {
      const open = header.getAttribute('aria-expanded') === 'true';
      header.setAttribute('aria-expanded', String(!open));
      body.classList.toggle('open', !open);
    });
  });

  /* ══ SIZE CHART POPUP ══ */
  const sizeChartLink    = $('#dpSizeChartLink');
  const sizeChartOverlay = $('#dpSizeChartOverlay');
  const sizeChartClose   = $('#dpSizeChartClose');

  if (sizeChartLink && sizeChartOverlay) {
    sizeChartLink.addEventListener('click', e => {
      e.preventDefault();
      sizeChartOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    function closeSC() { sizeChartOverlay.classList.remove('open'); document.body.style.overflow = ''; }
    if (sizeChartClose) sizeChartClose.addEventListener('click', closeSC);
    sizeChartOverlay.addEventListener('click', e => { if (e.target === sizeChartOverlay) closeSC(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeSC(); });
  }

  /* ══ PERSONALIZATION "LEARN MORE" POPUP ══ */
  const personalizationLearnMore = $('#dpPersonalizationLearnMore');
  const personalizationOverlay   = $('#dpPersonalizationOverlay');
  const personalizationClose     = $('#dpPersonalizationClose');

  if (personalizationLearnMore && personalizationOverlay) {
    personalizationLearnMore.addEventListener('click', e => {
      e.preventDefault();
      personalizationOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    function closePC() { personalizationOverlay.classList.remove('open'); document.body.style.overflow = ''; }
    if (personalizationClose) personalizationClose.addEventListener('click', closePC);
    personalizationOverlay.addEventListener('click', e => { if (e.target === personalizationOverlay) closePC(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closePC(); });
  }

  /* ══ RELATED PRODUCTS CAROUSEL ══ */
  const track    = $('#dpRelatedTrack');
  const prevCar  = $('#dpRelatedPrev');
  const nextCar  = $('#dpRelatedNext');
  if (track && prevCar && nextCar) {
    let pos = 0;
    const cards = [...track.children];
    const cols  = window.innerWidth > 860 ? 4 : 2;
    const max   = Math.max(0, cards.length - cols);
    function moveCar() {
      if (!cards.length) return;
      const w = cards[0].offsetWidth + 16;
      track.style.transform = `translateX(-${pos * w}px)`;
      prevCar.disabled = pos === 0;
      nextCar.disabled = pos >= max;
    }
    prevCar.addEventListener('click', () => { if(pos>0){ pos--; moveCar(); }});
    nextCar.addEventListener('click', () => { if(pos<max){ pos++; moveCar(); }});
    moveCar();
    window.addEventListener('resize', moveCar);
  }

  /* ══ UTILITY ══ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ══ CUSTOM APPLE PAY BUTTON (sticky bar) ══
     window.ApplePaySession only exists in Safari on Apple devices — this
     is the same check Apple's own docs recommend, no user-agent sniffing
     needed. It stays hidden everywhere else (Android, desktop Chrome, etc). */
  (function initApplePayBtn() {
    const btn = $('#dpApplePayBtn');
    if (!btn) return;

    const canUseApplePay =
      window.ApplePaySession &&
      typeof window.ApplePaySession.canMakePayments === 'function' &&
      window.ApplePaySession.canMakePayments();

    if (!canUseApplePay) return; // stays display:none
    btn.style.display = 'flex';

    btn.addEventListener('click', () => {
      const idInput = $('#dpVariantId');
      const variantId = idInput ? idInput.value : null;
      if (!variantId) return;

      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(r => {
          if (!r.ok) throw new Error('add to cart failed');
          window.location.href = '/checkout';
        })
        .catch(() => {
          btn.disabled = false;
          window.location.href = '/checkout'; // fall back — cart may already have the item from a prior add
        });
    });

    // Safari restores this exact page (including a disabled button) from its
    // back/forward cache when the shopper hits Back from checkout. Without
    // this, the button stays permanently disabled after one use.
    window.addEventListener('pageshow', () => {
      btn.disabled = false;
    });
  })();

})();